import {
  SET_ACTIVE_SCHEDULE_GROUP
} from '../actions';

export default function (state = {}, action) {

  switch(action.type) {
    case SET_ACTIVE_SCHEDULE_GROUP:
      return action.payload;

    default:
      return state;
  }
}